<template>
  <div class="header">
    <div class="logo">
      <span class="pic"></span>
      <!-- <svg-icon className="list-icon" icon-class="list"/> -->
      <a>红包商城运营管理后台</a>
    </div>
    <!-- <div class="f-nav">
      <FirstNav/>
    </div> -->
    <div class="h-r">
      <div class="user h-r-f" v-if="userinfo.username">
        <a class="h-r-t" href="javascript:;">{{userinfo.name}}</a>
        
      </div>
      <div class="modify_pas" @click="showModifyPassword">修改密码</div>
      <div class="login-out h-r-f" @click="handleLoginOut">
        <svg-icon className="close-icon" icon-class="close"/>
      </div>
    </div>

    <jdialog title="修改密码" :visible.sync = 'isshowModifyPassword'  width='540px'>
       <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
         <el-form-item label="旧密码" prop="name">
              <el-input v-model="ruleForm.password"></el-input>
         </el-form-item>
         <el-form-item label="新密码" prop="name">
              <el-input v-model="ruleForm.new_password" show-password></el-input>
         </el-form-item>
         <el-form-item label="确认新密码" prop="name">
              <el-input v-model="new_certain_password" show-password></el-input>
         </el-form-item>
       </el-form>

       <div style="padding:20px; text-align:center;">
         <el-button type="primary" size="mini" @click="certainModifyPas">确定</el-button>
         <el-button  size="mini" @click="cancelModifyPassword">取消</el-button>
       </div>
    </jdialog>
  </div>
</template>

<script>
// import FirstNav from './firstNav'
import {removeToken} from '@/utils/auth'
import {updatePassword} from "@/api/autarky";
export default {
  // components: {
  //   FirstNav
  // },
  data() {
    return {
      userinfo: {},
      isshowModifyPassword :false,
      ruleForm:{
        password:'',
        new_password:''
      },
      new_certain_password:'',
      rules:{
        password: [
            { required: true, message: '请输入旧密码', trigger: 'blur' },
          ],
          new_password: [
            { required: true, message: '请输入旧密码', trigger: 'blur' },
          ],
      }

    }
  },
  mounted() {
  },
  methods: {
    loginOut() {
       this.$router.push('/login')
        removeToken()
    },
    handleLoginOut() {
      this.$confirm('当前已登录，确认退出？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.loginOut()
      }).catch(() => {
        console.log('cancel')
      });
    },
    //修改密码
    showModifyPassword(){
      this.isshowModifyPassword = true
    },
    certainModifyPas(){
        if(!this.ruleForm.password){
          this.$message.error('旧密码不能为空')
          return
        }
        if(!this.ruleForm.new_password){
          this.$message.error('新密码不能为空')
          return
        }
        if(!this.new_certain_password){
          this.$message.error('确认新密码不能为空')
          return
        }
       if(this.new_certain_password !=  this.ruleForm.new_password){
         this.$message.error('新密码和确认新密码要相同')
         return
       }
       this.getupdatePasswordData()
    },
    async getupdatePasswordData() {
      let res = await updatePassword(this.ruleForm)
      if(res.code == 10000){
        this.$message.success(res.message)
        this.ruleForm.password = ''
      this.ruleForm.new_password = ''
      this.new_certain_password = ''
      this.isshowModifyPassword = false
      this.loginOut()
      }else {
        this.$message.error(res.message)
      }
    },
    cancelModifyPassword(){
      this.ruleForm.password = ''
      this.ruleForm.new_password = ''
      this.new_certain_password = ''
      this.isshowModifyPassword = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import './scss/header';

.logo {
  width: 300px;
  display: flex;
  justify-content: center;
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 1px;
    height: 18px;
    background-color: #d4d4d4;
  }
  .list-icon {
    color: #fff;
    font-size: 24px;
    cursor: pointer;
    &:hover {
      color: #3296fa;
    }
  }
  .pic {
    margin: 0;
    width: 56px;
    height: 56px;
    margin-right: 28px;
  }
}
.demo-ruleForm{
  padding: 30px 30px 0px 10px;;
}
.f-nav {
  float: left;
  margin-left: 28px;
}
.modify_pas{
  color: #fff;
  margin-right:12px;
  cursor: pointer;
}
.h-r {
  // .search-icon {
  //   font-size: 19px;
  //   margin-right: 2px;
  //   font-weight: bold;
  // }
  // .search-val {
  //   font-size: 14px;
  //   line-height: 20px;
  //   height: 20px;
  //   border: none;
  //   border-bottom: 1px solid #fff;
  //   background: none;
  //   color: #fff;
  //   width: 164px;
  //   padding: 0;
  //   &::-webkit-input-placeholder{
  //     color: #a1a1a1;
  //   }
  // }
  .user {
    .user-action {
      transform: translateX(0%);
      position: absolute;
      top: 72px;
      right: -50px;
      left: auto;
    }
  }
}
</style>